import React from 'react';
import { useAppointmentModal } from '../context/AppointmentModalContext';
import { useI18n } from '../i18n/I18nContext';
import './ClarityHero.css';

function ClarityHero() {
  const { openModal } = useAppointmentModal();
  const { copy } = useI18n();

  const scrollToRooms = (e) => {
    e.preventDefault();
    const target = document.getElementById('raeume');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="michaela-clarity-hero" aria-label={copy.home.heroAria}>
      <div className="michaela-clarity-hero-inner">
        <p className="michaela-clarity-hero-overline">
          {copy.home.eyebrow}
        </p>
        <h1 className="michaela-clarity-hero-title">
          {copy.home.title}
        </h1>
        <p className="michaela-clarity-hero-subline">
          {copy.home.sub}
        </p>
        <p className="michaela-clarity-hero-audience">
          {copy.home.audience}
        </p>
        <button
          type="button"
          className="michaela-clarity-hero-cta"
          onClick={openModal}
        >
          {copy.home.cta}
        </button>
        <a
          href="#raeume"
          className="michaela-clarity-hero-link"
          onClick={scrollToRooms}
        >
          {copy.home.roomsLink}
        </a>
      </div>
    </section>
  );
}

export default ClarityHero;
